export default __webpack_public_path__ + "static/media/2449.ec5772c9.png";